import React, { useRef } from 'react';
import GuidedTour from '../GuidedTour';

/**
 * PageTour — wrapper simples pra usar nas páginas do tenant.
 *
 * Junta num componente só:
 *   - Botão discreto "💡 Ver tutorial" (renderizado onde o pai quiser)
 *   - O GuidedTour em si, com auto-start na 1ª visita + reabrir via clique
 *
 * Uso típico no header da página:
 *
 *   <div className="page-header">
 *     <h2>Meus Serviços</h2>
 *     <p>Gerencie seu catálogo</p>
 *     <PageTour
 *       tourId="services"
 *       steps={[
 *         { selector: '[data-tour="new-btn"]', title: '...', content: '...', placement: 'bottom' },
 *         // ...
 *       ]}
 *     />
 *   </div>
 *
 * Steps com selector inexistente são PULADOS silenciosamente (não trava UI).
 */
export default function PageTour({ tourId, label = 'Ver tutorial', steps = [], autoStart = true }) {
  const tourRef = useRef(null);
  if (!steps || steps.length === 0) return null;

  return (
    <>
      <button
        type="button"
        className="tour-trigger"
        onClick={() => tourRef.current?.open()}
        aria-label={label}
      >
        <span aria-hidden="true">💡</span>
        {label}
      </button>
      <GuidedTour ref={tourRef} tourId={tourId} steps={steps} autoStart={autoStart} />
    </>
  );
}
